import { Button, styled, Typography } from "@mui/material";
import React from "react";

export function BasicButton(props) {
  return (
    <CustomButton
      variant={props.variant}
      size="large"
      {...props}
      sx={{
        textTransform: "uppercase",
        background: props.bg,
        borderColor: props.borderColorA,
        "&:focus": {
          borderColor: props.borderColorA,
        },
      }}
    >
      {props.icon && (
        <img src={props.icon} alt="icon" style={{ marginRight: "6px" }} />
      )}
      <ButtonLabel
        variant="button"
        className="primaryGradientBgLabel"
        sx={{
          color: props?.textColorA,
          textTransform: "uppercase",
        }}
      >
        {props.text}
      </ButtonLabel>
    </CustomButton>
  );
}

const CustomButton = styled(Button)(() => ({
  width: "48%",
  background: "#5E70CC",
  // className="submitButtonDisable_Th",
  "&.Mui-disabled": {
    background: "#bec6eb",
    boxShadow: "0px 3px 6px rgb(0 0 0 / 8%)",
    textTransform: "uppercase",
  },
}));

const ButtonLabel = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: "600",
  textTransform: "capitalize",
  paddingTop: "5px",
  paddingBottom: "5px",
}));
